:host {
  --width: auto;
  --height: 40px;
  --max-height: 40px;
  --border-color: transparent;
  --border-width: 0;
  --padding: 0;
  align-items: center;
  justify-content: center;

  img {
    width: var(--width);
    height: var(--height);
    max-height: var(--max-height);

    padding: var(--padding);

    border-width: var(--border-width);
    border-style: solid;
    border-radius: 50%;
    border-color: var(--border-color);

    background-clip: content-box;
  }
}
